import { render, staticRenderFns } from "./AuthBrandPanelSlide.vue?vue&type=template&id=b481d9f0&scoped=true"
import script from "./AuthBrandPanelSlide.vue?vue&type=script&lang=js"
export * from "./AuthBrandPanelSlide.vue?vue&type=script&lang=js"
import style0 from "./AuthBrandPanelSlide.vue?vue&type=style&index=0&id=b481d9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b481d9f0",
  null
  
)

export default component.exports